













































import { Component, Vue } from "vue-property-decorator";
import DeviceInfo from "@/models/deviceInfo.model";
import Map from "@/components/map.vue";
import DashboardTemplate from "@/views/Layouts/dashboard-template.vue";
import { dateFormatter } from "@/utils/utils";
import SelectionList from "@/components/selection-list.vue";
import { MutationTypes } from "@/store/devices/mutations";

@Component({
  components: {
    SelectionList,
    Map,
    DashboardTemplate
  },
})
export default class Home extends Vue {
  private filterVisible = false;
  private itemsToFilter: DeviceInfo[] = [];
  private filterString = "";
  private currentLocation: any = {};

  private mounted() {
    this.getCurrentLocation();
  }

  private openFilterDialog() {
    this.filterVisible = true;
    this.filterString = "";
    (this.$refs.listTable as SelectionList).initialize(this.$typedStore.getters.devicesWithLocations);
  }

  private onSelectionChange(items: DeviceInfo[]) {
    this.$typedStore.commit(MutationTypes.SetSelectedDevices, items);
  }

  private dateFormatter(row: any, column: any) {
    return dateFormatter(row, column);
  }

  private filterItem(item: DeviceInfo, filter: string) {
    return item &&
      (item.id && item.id.indexOf(filter.toUpperCase()) >= 0 ||
      item.label && item.label.toLowerCase().indexOf(filter) >= 0);
  }

  private filterFunction(items: DeviceInfo[]) {
    return items.filter((f) => (this.filterString && this.filterItem(f, this.filterString) || !this.filterString));
  }

  private getCurrentLocation() {
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    navigator.geolocation.getCurrentPosition((geoposition) => {
      this.currentLocation = {
        lat: geoposition.coords.latitude,
        lng: geoposition.coords.longitude
      };
    }, (error) => {
      this.currentLocation = {
        lat: 51.1940727,
        lng: 4.4341376
      };
    }, options);
  }
}
